'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var State = /*#__PURE__*/function () {
  function State(localId, remoteId) {
    _classCallCheck(this, State);

    this.setup();
    this.id.local = localId;
    this.id.remote = remoteId;
    this.key.local = localId.privKey;
  }

  _createClass(State, [{
    key: "setup",
    value: function setup() {
      this.id = {
        local: null,
        remote: null
      };
      this.key = {
        local: null,
        remote: null
      };
      this.shake = null;
      this.cleanSecrets();
    } // remove all data from the handshake that is not needed anymore

  }, {
    key: "cleanSecrets",
    value: function cleanSecrets() {
      this.shared = {};
      this.ephemeralKey = {
        local: null,
        remote: null
      };
      this.proposal = {
        in: null,
        out: null
      };
      this.proposalEncoded = {
        in: null,
        out: null
      };
      this.protocols = {
        local: null,
        remote: null
      };
      this.exchange = {
        in: null,
        out: null
      };
    }
  }]);

  return State;
}();

module.exports = State;